import React from 'react';
import {connect} from 'react-redux';
import {Navbar, Nav, NavItem} from 'react-bootstrap';
import menuItems from '../../menuItems';
import {BEGIN_YEAR} from '../../config';
import {END_YEAR} from '../../config';

const logo = require('../../images/logo-emd.png');


import '../../styles/header.less';


/** Entete du site (informations et actions) */
@connect(
  state => ({user: state.user, updates: state.updates, planning: state.planning, groomers: state.groomers}),
  {}
)
export default class HeaderComponent extends React.Component {

  constructor() {
    super();
    this.state = {
      alertsCount: 0,
      beginYear: BEGIN_YEAR,
      endYear: END_YEAR
    }
  }

  renderNavHeader() {
    return (
      <Navbar.Header>
        <Navbar.Brand>
          <img src={logo} className="site-logo"/>
        </Navbar.Brand>
        <Navbar.Toggle/>
      </Navbar.Header>
    );
  }

  renderButtons() {
    const {onPaneSelected, paneName, user} = this.props;
    const skiresort = user.selectedSkiresort;

    const items = menuItems.map(item => {
      if (item.admin && !user.infos.is_admin) {
        return null;
      }
      return (
        <NavItem key={ item.paneName }>
          <div
            className={ ['action-tab', paneName === item.paneName ? 'selected' : null].join(' ') }
            onClick={() => onPaneSelected(item.paneName)}>
            { item.icon}
          </div>
        </NavItem>
      );
    });

    return (
      <Navbar.Collapse timeout={1}>
        <Nav pullRight>
          { items }
          {  user.infos.ski_resorts.length === 1 ? null :
            <NavItem>
              <div className="action-app swap" key="actionSwap"
                   onClick={() => onPaneSelected('switchskiresort')}>
                <i className="mi mi-swap-horiz"/>
              </div>
            </NavItem>
          }
          <NavItem>
            <img alt={skiresort.name} className="resort-logo" src={skiresort.logoUrl}/>
          </NavItem>
        </Nav>
      </Navbar.Collapse>
    );
  }

  renderConnectedHeader() {
    return (
      <Navbar fluid>
        { this.renderNavHeader() }
        <Nav className="hidden-xs">
          <NavItem className="subtitle">
            ATI Chauffeur Dameuse
          </NavItem>
        </Nav>
        { this.renderButtons() }
      </Navbar>
    );
  }

  renderOfflineHeader() {
    return (
      <Navbar fluid className="offline">
        <i className="mi mi-warning"/>
        <span>Déconnecté</span>
        <i className="mi mi-warning"/>
      </Navbar>
    );
  }

  render() {
    if (this.props.updates.connected) {
      return this.renderConnectedHeader();
    } else {
      return this.renderOfflineHeader();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/HeaderComponent.js